import axios from 'axios'
import { getAPICSURL, getAPIURL } from '../../GlobalComponents/URLs'
import { fetchGetCurrentUser } from '../../features/meta/metaAPI'

export interface PointOfSaleReport {
    id: number
    reportName: string
    description: string
    frequency: string
    active: boolean
    runBy: string
    lastRun: Date
    success: boolean
    failureReason: string
    dateRange: string
}

export interface PointOfSaleReportDetail {
    id: number
    reportName: string
    description: string
    frequency: string
    active: boolean
    emailSubject: string
    emailRecipients: string
    emailCCRecipients: string
    emailVerbiage: string
    reportType: string
    pointOfSaleReportLogs: Array<PointOfSaleReportLog>
}

// Empty PointOfSaleReportDetail
export const emptyPointOfSaleReportDetail: PointOfSaleReportDetail = {
    id: 0,
    reportName: '',
    description: '',
    frequency: '',
    active: false,
    emailSubject: '',
    emailRecipients: '',
    emailCCRecipients: '',
    emailVerbiage: '',
    reportType: '',
    pointOfSaleReportLogs: [],
}

export interface PointOfSaleReportAdhocDetail {
    reportName: string
    vendorID: string
    fromDate: Date | null
    toDate: Date | null
    emailRecipients: string
    emailCCRecipients: string
    reportType: string
    includeFieldnames: boolean
}

export const emptyPointOfSaleReportAdhocDetail: PointOfSaleReportAdhocDetail = {
    reportName: '',
    vendorID: '',
    fromDate: null,
    toDate: null,
    emailRecipients: '',
    emailCCRecipients: '',
    reportType: '',
    includeFieldnames: false,
}

export interface PointOfSaleReportLog {
    id: number
    pointOfSaleReportId: number
    fromDate: Date
    toDate: Date
    runDate: Date
    success: boolean
    emailRecipients: string
    emailCCRecipients: string
    failureReason: string
    runBy: string
}

export interface PointOfSaleReportSaveResponse {
    Success: boolean
    Reason: string
}

export const fetchPointOfSaleManager = async (): Promise<Array<PointOfSaleReport>> => {
    let currentUser = await fetchGetCurrentUser()
    let url = `${getAPICSURL()}PointOfSaleReport/GetPointOfSaleReportManager`
    let resp = await fetch(url, {
        method: 'GET',
        // mode: 'cors',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            Company: currentUser.CompanyCode,
        },
    })
        .then((resp) => {
            if (resp.ok) {
                return resp.json()
            } else {
                throw new Error('bad request ' + resp.statusText)
            }
        })
        .then((json: PointOfSaleReport[]) => {
            if (json.length > 0) {
                json.map((pos: PointOfSaleReport) => {
                    pos.lastRun = new Date(pos.lastRun)
                })
            }

            return json
        })

    let json: PointOfSaleReport[] = resp
    return json
}

export interface FetchPointOfSaleReportDetailParams {
    ID: number
}

export const fetchPointOfSaleReportDetail = async (
    payload: FetchPointOfSaleReportDetailParams
): Promise<PointOfSaleReportDetail> => {
    let currentUser = await fetchGetCurrentUser()
    let url = `${getAPICSURL()}PointOfSaleReport/GetPointOfSaleReportByID/${payload.ID}`
    let resp = await fetch(url, {
        method: 'GET',
        // mode: 'cors',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            Company: currentUser.CompanyCode,
        },
    })
        .then((resp) => {
            if (resp.ok) {
                return resp.json()
            } else {
                throw new Error('bad request ' + resp.statusText)
            }
        })
        .then((json: PointOfSaleReportDetail) => {
            if (json.pointOfSaleReportLogs.length > 0) {
                json.pointOfSaleReportLogs.map((poslog: PointOfSaleReportLog) => {
                    poslog.fromDate = new Date(poslog.fromDate)
                    poslog.toDate = new Date(poslog.toDate)
                    poslog.runDate = new Date(poslog.runDate)
                })
            }

            return json
        })

    let json: PointOfSaleReportDetail = resp
    return json
}

export const UpdatePointOfSaleReportDetail = async (
    savePointOfSaleReportDetail: PointOfSaleReportDetail
): Promise<boolean> => {
    let currentUser = await fetchGetCurrentUser()
    let result: boolean = false
    const headers = {
        'Content-Type': 'application/json',
        Company: currentUser.CompanyCode,
    }
    await axios
        .put(`${getAPICSURL()}PointOfSaleReport`, savePointOfSaleReportDetail, {
            headers,
        })
        .then((response: any) => {
            if (response) {
                result = true
            } else {
                result = false
            }
        })
        .catch(async (error: any) => {
            console.error(error.message)
            result = false
        })
    return result
}
export const fetchSavePointOfSaleReportDetail = async (
    savePointOfSaleReportDetail: PointOfSaleReportDetail
): Promise<PointOfSaleReportSaveResponse> => {
    const url = `${getAPICSURL()}PointOfSaleReport`
    let saveResult: PointOfSaleReportSaveResponse
    let currentUser = await fetchGetCurrentUser()
    let saveResponse: PointOfSaleReportSaveResponse = await fetch(url, {
        method: 'PUT',
        mode: 'cors',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            Company: currentUser.CompanyCode,
        },
        body: JSON.stringify({ PointOfSaleReportDetail: [savePointOfSaleReportDetail] }),
    })
        .then((response) => {
            if (response.ok) {
                saveResult.Success = true
                saveResult.Reason = ''
                return saveResult

                // getPointOfSaleManager() // Refresh grid data
                // return response.json()
            } else {
                throw new Error('bad request ' + response.statusText)
            }

            // throw new Error('bad request ' + response.statusText)
            // throw response
        })
        .catch(async (error) => {
            const e = await error.text()
            console.error('Error fetching point of sale grid data: ', e)
            saveResult.Success = false
            saveResult.Reason = 'Error fetching point of sale grid data: ' + e
            return saveResult
            // throw new Error('Error fetching point of sale grid data: ' + e)
            // setError(e)
        })

    return saveResponse
}

export interface SubmitPointOfSaleAdhocParams {
    Username: string
    Email: string
    paramsString: string
}

export const SubmitPointOfSaleReportAdhoc = async (
    params: SubmitPointOfSaleAdhocParams
): Promise<Boolean> => {
    let url = getAPIURL() + 'master/batchqueue/submit'
    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            ProgDomain: 'InvoiceReports',
            ProgName: 'MasterBatch',
            Params: params.paramsString,
            Username: params.Username,
            Email: params.Email,
            Crystal: true,
        }),
    })
    return req.ok
}
